var responsiveToolkit = require('src/interlock/no-ui/utils/responsive-bootstrap-toolkit/responsive-bootstrap-toolkit');
var utilities = require('src/interlock/product/ads/ad-tags/async-gpt-tag-utilities');
var breakpointCheck = utilities.breakpointCheck(responsiveToolkit);

var deepLinkData1 = require('src/creative/core-page/deep-link/deep-link-data');
var deepLinkData2 = require('src/creative/core-page/deep-link/deep-link-data2');
var deepLinkData3 = require('src/creative/core-page/deep-link/deep-link-data3');
var oem = $.extend(deepLinkData1.oem1, deepLinkData2.oem2, deepLinkData3.oem3);
var $buildDeepLink = $('.core-build-module .build-deep-link');
var vehicle = {};

var findColors = require('./find-colors');

function getVehicleByStyleId(styleId){
    return $.getJSON (
        '/api/vehicle/v2/styles/' + styleId + '?view=full'
    );
}

var getVehicle = function(styleId) {
    return getVehicleByStyleId(styleId).then(prettify);
};

var prettify = function(vehicleData) {
    vehicleModel(vehicleData);
    vehicleTrain(vehicleData);
    vehicleTrim(vehicleData);
    vehicleOptions(vehicleData);
    vehicleCode(vehicleData);
    checkYear(vehicleData);

    findColors.vehicleColors(vehicleData);
    $.extend(vehicle, findColors.vehicle);
    makeDeepLink();
};

function vehicleModel(data) {
    vehicle.name = data.make.name;
    vehicle.niceName = data.make.niceName;
    vehicle.model = data.model.niceName;
    vehicle.submodel = data.submodel.niceName;
}
function vehicleCode(data) {
    vehicle.code = data.manufacturerCode || '';
    vehicle.crossover = data.categories.crossover || '';
}
function vehicleTrain(data) {
    vehicle.driveTrain = '';
    vehicle.transmission = data.transmission.transmissionType || '';

    if(data.drivenWheels.indexOf('front') > -1) {
        vehicle.driveTrain = 'FWD';
    }
    if(data.drivenWheels.indexOf('rear') > -1) {
        vehicle.driveTrain = 'RWD';
    }
    if(data.drivenWheels.indexOf('all') > -1) {
        vehicle.driveTrain = 'AWD';
    }
}
function vehicleTrim(data) {
    vehicle.trim = data.trim || '';
    vehicle.id = data.model.id.toLowerCase();
}
function vehicleOptions() {
    vehicle.pageNumber = 2;
    vehicle.package = '';
    vehicle.option = '';
}
function checkYear(data) {
    vehicle.year = data.year.year || null;
    if(vehicle.year == null) {
        if($('.legacy-linkout')[0]) {
            vehicle.year = $('.legacy-linkout')[0].href.split('/')[5];
        }
    }
}

function makeDeepLink() {
    var deepLinkOem = oem[vehicle.niceName.split('-')[0]];
    if(!deepLinkOem) { return; }
    var deepLink = deepLinkOem.build(vehicle);

    if(vehicle.year != '2015' && deepLink &&
      (!breakpointCheck('<=sm') || ['acura','honda','lexus'].includes(vehicle.make.toLowerCase()))) {

        var punitWrapper = document.createElement('div'),
            punit = document.createElement('div');

        punitWrapper.classList.add('punit-wrapper');
        punit.classList.add('punit');
        punit.classList.add('hidden-xs-up');
        punit.setAttribute('data-targeting', 'pos=1;adname=deeplink');

        $buildDeepLink.attr('href', deepLink);

        if(['nv200', 'nv-cargo', 'nv-passenger'].includes(vehicle.model.toLowerCase())) {
            $buildDeepLink.find('.link-message').text(deepLinkOem['message-van']);
        } else {
            $buildDeepLink.find('.link-message').text(deepLinkOem.message);
        }

        $buildDeepLink.removeClass('hidden-xs-up');
        punitWrapper.appendChild(punit);
        $buildDeepLink[0].appendChild(punitWrapper);
        $buildDeepLink.find('.punit').asyncGptTag({});
    }
}

module.exports = {
    getVehicle: getVehicle
};


//////////////////
// WEBPACK FOOTER
// ./src/creative/core-page/build/build-data.js
// module id = 171
// module chunks = 0 1 23